import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Input, Menu, Segment } from 'semantic-ui-react';
import styled from 'styled-components';

class Tabs extends Component {
  render() {
    const { topMenuProps, activeItem, children } = this.props;
    const { fn, tabAuth, items } = topMenuProps;

    return (
      <Fragment>
        <TabMenuStyle attached="top" tabular>
          <TabMenuItemStyle
            name="식대신청 내역"
            active={activeItem === '식대신청 내역'}
            onClick={() => fn.tabMove('식대신청 내역')}
          />
          {tabAuth ? (
            <TabMenuItemStyle
              name="식대신청 승인 권한 관리"
              active={activeItem === '식대신청 승인 권한 관리'}
              onClick={() => fn.tabMove('식대신청 승인 권한 관리')}
            />
          ) : (
            <TabMenuItemStyle name="식대신청 승인 권한 관리" disabled />
          )}
        </TabMenuStyle>

        <TabMenuBodyStyle attached="bottom">{children}</TabMenuBodyStyle>
      </Fragment>
    );
  }
}

const TabMenuStyle = styled(Menu)``;

const TabMenuItemStyle = styled(Menu.Item)`
  &&&& {
    display: inline-block;
    width: 50%;
    padding: 11px 0 12px;
    height: 40;
    text-align: center;
    border-top: 3px solid #dcdcdc;
    background-color: #f8f8f8;
    color: rgba(0, 0, 0, 0.87);
    font-weight: bold;
    border-left: 1px solid #dcdcdc;
    border-right: 1px solid #dcdcdc;

    &:hover,
    &.active {
      border-radius: 0 !important;
      background: #fff;
      border-top: 3px solid #0bb656;
      border-bottom: 0;
      color: #0bb656;
    }

    &.disabled {
      background: #f8f8f8 !important;

      &:hover {
        border-color: #dcdcdc;
        color: rgba(0, 0, 0, 0.87);
        cursor: no-drop;
      }
    }
  }
`;

const TabMenuBodyStyle = styled(Segment)`
  border: 0 !important;
  border-radius: 0 !important;
  padding: 26px 0 0 !important;
`;

export default Tabs;
